import { render, staticRenderFns } from "./breeder-details-container.vue?vue&type=template&id=2cd93142&scoped=true&lang=pug"
import script from "./breeder-details-container.js?vue&type=script&lang=js&external"
export * from "./breeder-details-container.js?vue&type=script&lang=js&external"
import style0 from "./breeder-details-container.vue?vue&type=style&index=0&id=2cd93142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd93142",
  null
  
)

export default component.exports